import { Lock } from 'lucide-react'

import { EmptyState } from '@/components/feedback/EmptyState'
import { messages } from '@/lib/messages'

/**
 * Veri yüzeylerinin dört zorunlu durumundan biri (AGENTS.md §10).
 * Adres çubuğundan doğrudan girilen yetkisiz rota için gösterilir (sözleşme §4).
 */
export function Forbidden() {
  return (
    <EmptyState
      className="flex-1 justify-center"
      title={messages.states.forbiddenTitle}
      description={messages.states.forbiddenHint}
      icon={<Lock className="size-6" strokeWidth={1.5} />}
    />
  )
}
